import React from "react";

const BlinkingDot = ({ isBlink = false }) => {
  return (
    <div
      className={isBlink ? `blinker_blinking-dot blinkblink` : `blinkblink`}
    />
  );
};

export default React.memo(BlinkingDot);
